// SubHeroSection.jsx
import React from 'react';
import './SubHero.css';

function SubHero({ title, subtitle, image }) {
  return (
    <div className="SubHero-container">
      <div className="SubHero-background">
        <img 
          src={image}
          alt="Hero image" 
          className="SubHero-image"
        />
        <div className="SubHero-overlay"></div>
      </div>
      
      <div className="SubHero-content">
        <h1 className="SubHero-title header-1"> {title} </h1>
        <p className="SubHero-subtitle text-1"> {subtitle} </p>
      </div>
    </div>
  );
}

export default SubHero;